
<template>
  <div v-if="isInRole(['techsupport'])">
    <toolbar />
    <zlick-navigation />
   <v-container fluid text-xs-center>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-text>
            <v-flex xs12 offset-xs0>
              <h3>{{$t('retry_webhook')}}</h3>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">{{$t('cancel')}}</v-btn>
            <v-btn color="blue darken-1" flat @click.native="updateState">{{$t('confirm')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-container v-if="!error" fluid text-xs-center>
    <v-layout row wrap center>
      <v-flex xs12 offset-xs0>
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :total-items="getTotalItems"
          item-key="_id"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <tr>
            <td @click="props.expanded = expanded(props.expanded)">{{ formatDate(props.item.createdAt) }}</td>
            <td @click="props.expanded = expanded(props.expanded)">{{ formatDate(props.item.updatedAt) }}</td>
            <td @click="props.expanded = expanded(props.expanded)" class="text-xs-center"><a>{{ props.item.url }}</a></td>
            <td @click="props.expanded = expanded(props.expanded)" class="text-xs-center">{{ props.item.eventId }}</td>
            <td @click="props.expanded = expanded(props.expanded)" class="text-xs-center">
              <v-chip
                class="ma-2"
                :color="getColor(props.item.status)"
                text-color="white"
                label
              >
                {{props.item.status}}
              </v-chip>
            </td>
            <td @click="props.expanded = expanded(props.expanded)" class="text-xs-center">{{ props.item.type }}</td>
            <td class="text-xs-center">
              <v-btn icon class="mx-0" @click="showRetryBox(props.item)">
                <v-icon color="blue">autorenew</v-icon>
              </v-btn>
            </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card dark class="scrollable h450px">
              <v-tabs v-model="tab">
                <v-tab :class="{active: currentTab === 0}" @click="currentTab = 0">{{$t("request")}}</v-tab>
                <v-tab :class="{active: currentTab === 1}" @click="currentTab = 1">{{$t("responses")}}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                  <div v-show="currentTab === 0">
                        <div class="custom-style1">
                          <v-banner>
                            {{$t("requestBody")}}
                          </v-banner>
                        </div>
                        <v-divider></v-divider>
                        <div class="text-align-left custom-style2">
                          <vue-json-pretty
                            :showLine="true"
                            :data="props.item.request"
                            >
                          </vue-json-pretty>
                        </div>
                  </div>
                  <div v-show="currentTab === 1">
                      <template v-if="props.item.response.length">
                        <v-data-table dark disable-sort :headers="headers2" :items="[props.item.response[pagination2.page - 1] || props.item.response[0]]" hide-actions>
                          <template slot="items" slot-scope="response">
                            <td>
                              <div class="text-align-left">
                                <vue-json-pretty
                                  :showLine="true"
                                  :data="response.item"
                                  >
                                </vue-json-pretty>
                              </div>
                            </td>
                          </template>
                        </v-data-table>
                        <v-container fill-height fluid>
                          <v-layout align-center>
                            <v-flex>
                              <v-row class="right">
                                <h3 class="blue--text">{{$t('retryAttempts')}}</h3>
                              </v-row>
                            </v-flex>
                            <v-flex>
                              <v-pagination
                                :total-visible="8"
                                v-model="pagination2.page"
                                :length="props.item.response.length || 0"
                                class="left"
                              />
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </template>
                      <template v-if="!props.item.response.length">
                           <v-card>
                              <v-card-text>
                                {{$t("noResponseFromWebhook")}}
                              </v-card-text>
                            </v-card>
                      </template>
                  </div>
            </v-tabs-items>
            </v-card>
          </template>
          <template slot="no-data">
          <!-- i18n-please -->
            <v-btn color="primary" @click="initialize">{{$t('reset')}}</v-btn>
          </template>
        </v-data-table>
      </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="!error" fluid text-xs-center>
      <v-pagination
        v-model="pagination.page"
        :length="pagesCount"
        @input="newPage(pagination.page)"
      />
    </v-container>
    <v-container v-if="error" grid-list-md>
      <v-layout row justify-center>
        <v-flex xs12 offset-xs4>
          <v-text-field color="error" v-text="error"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import Toolbar from './Toolbar'
import ZlickNavigation from './ZlickNavigation'
import WebhookLogsService from '../services/WebhookLogsService'
import moment from 'moment'
import AuthenticationService from '../services/AuthenticationService'
import Raygun from '../services/Raygun'
import { mapState } from 'vuex'
import VueJsonPretty from 'vue-json-pretty'

export default {
  components: {
    Toolbar,
    ZlickNavigation,
    VueJsonPretty
  },
  data: function () {
    return {
      currentTab: 0,
      tab: null,
      dialog: false,
      itemToRetry: '',
      headers: [
        {text: this.$t('createdAt'), value: 'createdAt', align: 'center'},
        {text: this.$t('updatedAt'), value: 'updatedAt', align: 'center'},
        {text: this.$t('urlWebHook'), value: 'url', align: 'center'},
        {text: this.$t('eventId'), value: 'eventId', align: 'center'},
        {text: this.$t('status'), value: 'status', align: 'center'},
        {text: this.$t('transactionType'), value: 'type', align: 'center'},
        {text: this.$t('retry'), value: 'type', align: 'center'}
      ],
      headers2: [
        {text: this.$t('responseBody'), value: 'response', align: 'center'}
      ],
      snackbar: {
        timeout: 4000,
        color: 'success',
        mode: 'vertical',
        show: false
      },
      error: null
    }
  },
  beforeCreate () {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.push('/login')
    }
  },
  created () {
    this.initialize()
  },
  watch: {

    activeCognitoGroup (newValue, oldValue) {
      console.log(`cognito Updating from ${oldValue} to ${newValue}`)
      this.initialize()
    },

    pagination: {
      handler () {
        this.$store.dispatch('sortWebhooklogs')
      },
      deep: true
    }
  },

  computed: {

    ...mapState({
      activeCognitoGroup: state => state.user.activeCognitoGroup
    }),

    pagination: {
      get: function () {
        return this.$store.state.pagination
      },
      set: function (newValue) {
        this.$store.commit('setPagination', newValue)
      }
    },
    pagination2: {
      get: function () {
        return this.$store.state.pagination2
      },
      set: function (newValue) {
        this.$store.commit('setPagination2', newValue)
      }
    },
    items: {
      get: function () {
        return this.$store.state.webhooklogs.docs
      },
      set: function (newValue) {
        this.$store.commit('setWebhooklogs', newValue)
      }
    },
    getTotalItems () {
      return this.$store.state.webhooklogs.total
    },
    pagesCount () {
      let totalItems = this.$store.state.webhooklogs.total
      if (!totalItems || totalItems === 0) return 0
      return Math.ceil(totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    isInRole (roles) {
      return AuthenticationService.isInRole(roles)
    },
    async newPage (page) {
      let searchValue = this.$store.state.searchValue
      let dateRange = this.$store.state.dateRange

      if (!searchValue && this.objectIsEmpty(dateRange)) {
        this.initialize(page)
      } else {
        let searchQuery = {
          searchValue,
          dates: {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate
          }
        }
        let response = await WebhookLogsService.search({searchQuery, page, limit: this.pagination.rowsPerPage})
        this.$store.commit('setWebhooklogs', response.data)
      }
    },
    expanded (expanded) {
      this.pagination2.page = 1
      return !expanded
    },
    objectIsEmpty (object) {
      return Object.keys(object).length === 0 && object.constructor === Object
    },
    showRetryBox (item) {
      this.dialog = true
      this.itemToRetry = item
    },
    getColor (status) {
      switch (status) {
        case 'success':
          return 'green accent-4'
        case 'pending':
          return 'orange darken-2'
        case 'failed':
          return 'red'
        default:
          return ''
      }
    },
    close () {
      this.dialog = false
    },

    async initialize (page = 1, limit = 20) {
      try {
        this.error = null
        let response = await WebhookLogsService.search({page, limit})
        this.$store.commit('setWebhooklogs', response.data)
      } catch (error) {
        this.error = error.message
        Raygun.send(error)
      }
    },

    formatDate (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },

    async updateState () {
      try {
        await WebhookLogsService.updateState({webhookLogsId: this.itemToRetry._id})
        this.initialize()
      } catch (error) {
        Raygun.send(error)
        this.snackbar.show = true
        this.snackbar.color = 'error'
        this.snackbar.text = 'Failed to update webhook log\'s state'
      } finally {
        this.close()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .text-align-left {
    text-align: left;
  }
  .vjs-key {
    font-size: smaller;
  }
  .vjs-value{
    font-size: smaller;
  }
</style>

<style scoped>
  .custom-style1{
    padding: 19px;
    font-size: 12px;
    font-weight: 500;
  }
  .custom-style2{
    padding: 0px 0px 57px 24px;
  }
  .scrollable{
      overflow-y: scroll;
      overflow-x: hidden;
  }
  .h450px{
    max-height: 450px;
  }
</style>



// WEBPACK FOOTER //
// src/components/WebhookLogs.vue